import { denormalize } from "normalizr";
import { groupMember } from "../../../api/schema";

export default state => {
  try {
    const items = state.groups.members.ids;

    const denormalized = denormalize(
      { items },
      { items: [groupMember] },
      state.entities
    );
    return denormalized.items || [];
  } catch (err) {
    return [];
  }
};
